import { Box as MBox, BoxProps } from '@mui/material'

export const Box: React.FC<BoxProps> = (props) => {
  return <MBox {...props} />
}
